<template>
  <div class="advantage">
    <section>
      <div class="advantage-banner">
        <img :src="bannerLink" >
      </div>
    </section>

    <!-- 一体两翼三轮驱动 -->
    <section id="drive">
      <div class="w-[1350px] mx-auto" style="margin-bottom: 130px">
        <div class="py-[80px] text-[40px] font-bold font-s32">一体两翼三轮驱动</div>
        <img width="100%" src="../../assets/images/advantage/drive.png" >
      </div>

      <!-- 强势教研翼 -->
      <Research />

      <!-- 领先科技翼 -->
      <section class="bg-[#2A3451]">
        <div class="w-[1350px] mx-auto pb-[80px]">
          <div class="pt-[80px] pb-[60px] text-[40px] font-bold text-white font-s32">领先科技翼</div>
          <img src="../../assets/images/advantage/technology.png" width="100%" alt="领先科技翼">
        </div>
      </section>
    </section>

    <!-- 高通过库课引擎 -->
    <section id="pass">
      <section class="w-[1350px] mx-auto pb-[88px]">
        <div class="py-[80px] text-[40px] font-bold font-s40">高通过库课引擎</div>
        <div class="text-[16px] leading-[27px] mb-[32px]">
          库课科技集团，作为学历及就业提升教育的领军企业，秉承着深厚的利他精神，致力于为天下学子成就美好人生。在这一宏伟使命的引领下，库课通过持续深耕、不懈追求与实践，积累出一套助力学子成功上岸的方法体系——「高通过库课引擎」，这是库课科技集团能够立于不败之地的根基。<br/>
          「高通过库课引擎」是库课科技集团强大的教学教研团队在长期教学教研实践中，基于对教育本质的深刻洞察和对市场需求的精准把握，逐步构建和完善的成果。实现了从集团层面到教研、教师、教材教辅到教学五大层面的深度融合与协同，构建了一个高效、协调、统一的11维核心竞争力体系。这一体系不仅彰显了库课科技集团在教育领域持续深耕的初心与决心，更是权威性、专业性和卓越成就的代表。
        </div>
        <img src="../../assets/images/advantage/pass.png" width="100%" alt="高通过库课引擎">
      </section>

      <section class="relative mx-auto pb-[88px] mb-[-80px] mt-[-180px]">
<!--        <div class="text-[40px] font-bold absolute top-[80px] left-[228px] fuk font-s32">11维核心竞争力<br/>助力学子成功上岸</div>-->
        <img src="../../assets/images/advantage/11dimensionality.png" width="100%" alt="11维核心竞争力助力学子成功上岸">
      </section>
    </section>

    <!-- 库课云Al+教育 -->
    <section id="ai" class="w-[1350px] mx-auto mb-[80px]">
      <div class="pt-[80px] mb-[60px] text-[40px] font-bold font-s40">库课云 AI+教育</div>
      <img src="../../assets/images/advantage/ai.png" width="100%" alt="库课云 AI+教育">
    </section>

      <!-- 知识产权体系 -->
    <section id="knowledge">
      <div class="relative">
        <div class="absolute top-[80px] text-[40px] font-bold fuk0 font-s40">知识产权体系</div>
        <img width="100%" src="../../assets/images/advantage/intellectual.png" alt="知识产权体系">
      </div>
      <div class="advantage-intellectual pb-[80px] pt-[93px]" id="knowledge">
        <div class="swiper">
          <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide v-for="(list, index) in intellectualProperty.list" :key="index">
              <img :class="[ index < 8 ? 'long-img' : 'wide-img'  ]" :src="list"/>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import metaInfo from '@/common/util/metaInfo'
import { advantageData } from '@/common/util/data.js';
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
// import { sleep } from '@/utils/common.js';
import Research from './components/Research.vue'

export default {
  name:"Index",
  metaInfo: metaInfo.Advantage,
  components: { swiper, swiperSlide,Research },
  data() {
    return {
      ...advantageData,
      swiperOptions: {
        pagination: {
          el: ".swiper-pagination", //与slot="pagination"处 class 一致
          clickable: true, //轮播按钮支持点击
          bulletClass: "my-bullet",
          bulletActiveClass: "my-bullet-active",
          renderBullet: function (index, className) {
            let text;
            switch (index) {
              case 0:
                text = "计算机软著专利（节选）";
                break;
              case 1:
                text = "外观设计类专利（节选）";
                break;
              case 2:
                text = "图书作品登记专利（节选）";
                break;
            }
            return '<span class="' + className + '">' + text + "</span>";
          },
        },
        loop: true,
        speed: 3000,
        slidesPerView: 4,
        slidesPerGroup: 4,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
      },
      activeEcologyIndex: 0,
      timer: null,
      isFadeIn: false,
      // maps:[]
    }
  },
  // computed: {
  //   activeMap() {
  //     return this.layout.maps[this.layout.activeIndex]
  //   },
  //   mapButtons() {
  //     return this.layout.maps.map(item => item.title)
  //   },
  // },
  mounted() {
    // this.maps = [this.layout.maps[this.layout.activeIndex].img]
    // this.initTimer()
  },
  methods: {
    // initTimer() {
    //   this.timer = setInterval(async () => {
    //     this.maps.splice(0,1)
    //     this.layout.activeIndex = this.layout.activeIndex >= 2 ? 0 : (this.layout.activeIndex + 1)
    //     await sleep(800)
    //     this.maps.splice(0, 0, this.layout.maps[this.layout.activeIndex].img)
    //   }, 3500);
    // },
    // clearTimer() {
    //   clearInterval(this.timer)
    //   this.timer = null
    // },
    // async mapChange(index) {
    //   this.clearTimer()
    //   this.maps.splice(0, 1)
    //   this.layout.activeIndex = index
    //   await sleep(800)
    //   this.maps.splice(0, 0, this.layout.maps[index].img)
    //   this.initTimer()
    // }
  },
  beforeDestroy() {
    // this.clearTimer()
  }
}
</script>
<style scoped lang="less">
@media screen and (max-width: 1919px) {
  .swiper-slide {
    .long-img {
      width: 143px;
      height: 195px;
    }
    .wide-img {
      width: 192px;
      height: 140px;
    }
  }
    
}
  
@media screen and (min-width: 1920px) {
  .swiper-slide {
    .long-img {
      width: 190px;
      height: 260px;
    }
    .wide-img {
      width: 256px;
      height: 186px;
    }
  }
}

img {
  display: block;
}

.advantage-title {
  font-size: 40px;
  margin-left: 12.5%;
  text-align: left;
}
.advantage {
  &-banner {
    >img {
      width: 100vw;
      height: auto;
      object-fit: cover;
    }
  }
  .advantage-intellectual {
    background-image: url('../../assets/images/advantage/bg_zzcq@2x.png');
    background-size: cover;
    background-repeat: no-repeat;
    .advantage-title {
      color: #fff;
    }
    .advantage-subtitle {
      color: #fff;
      font-size: 16px;
      line-height: 24px;
      padding-left: 12.5%;
      margin-top: 40px;
      width: 75%;
      font-weight: 400;
    }
    .swiper {
      margin: 0 auto;
      width: 75%;
        .swiper-container {
          width: 100%;
          padding-top: 120px;
          :deep(.swiper-wrapper) {
            align-items: center;
          }
    
          .swiper-slide {
            width: 100%;
            background-size: cover;
            background-position: center center;
            background-repeat: no-repeat;
            display: flex;
            align-items: center;
          }
    
          .swiper-pagination {
            text-align: left;
    
            ::v-deep {
              .my-bullet {
                text-align: center;
                cursor: pointer;
                display: inline-block;
                width: 278px;
                height: 60px;
                line-height: 60px;
                border-radius: 2px;
                font-weight: bold;
                background: rgba(255, 255, 255, 0.1);
                color: #fff;
                border: 1px solid rgba(255, 255, 255, 0.11);
                backdrop-filter: blur(10px);
              }
    
              .my-bullet:nth-child(2) {
                margin-left: 20px;
                margin-right: 20px;
              }
    
              .my-bullet-active {
                background: #cd3324;
                opacity: 1;
              }
            }
          }
        }
    
        .swiper-pagination-fraction,
        .swiper-pagination-custom,
        .swiper-container-horizontal>.swiper-pagination-bullets {
          top: 0px;
        }
      }
  }
}
</style>
<style>

.font-s32 {
  font-size: 32px !important;
}

.font-s40 {
  font-size: 40px !important;
}

.fuk {
  margin-left: -150px !important;
}

@media screen and (min-width: 1920px) {
  .fuk {
    margin-left: 50px !important;
  }
}

.fuk0 {
  left: 12.3%;
}

</style>